import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { EMAIL_API_CONFIG, EmailApiConfig } from './services/email-api.service';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: EMAIL_API_CONFIG,
      useValue: {
        baseUrl:
          'https://disposable-email-relay.dev.advertiser-mastertag.awin.com',
      } as EmailApiConfig,
    },
  ],
};
